// Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import { Pipe } from '@angular/core';
import { FileSizePipe } from 'ngx-filesize';
import { IDrive } from '../../../types/drive';
import { IVolume } from '../../../types/subscription';

// See https://www.npmjs.com/package/filesize
// transform(500);                        // "500 B"
// transform(500, {bits: true});          // "4 kbit"
// transform(265318, {base: 2});          // "259.1 KiB"
// transform(265318);                     // "265.32 kB"
// transform(265318, {round: 0});         // "265 kB"
// transform(265318, {output: "array"});  // [265.32, "kB"]
// transform(265318, {output: "object"}); // {value: 265.32, symbol: "kB", exponent: 1, unit: "kB"}
// transform(1, {symbols: {B: "Б"}});     // "1 Б"
// transform(1024);                       // "1.02 kB"
// transform(1024, {exponent: 0});        // "1024 B"
// transform(1024, {output: "exponent"}); // 1
// transform(265318, {standard: "jedec"});  // "259.1 KB"
// transform(265318, {base: 2, fullform: true}); // "259.1 kibibytes"
// transform(12, {fullform: true, fullforms: ["байтов"]});  // "12 байтов"
// transform(265318, {separator: ","});   // "265,32 kB"
// transform(265318, {locale: "de"});   // "265,32 kB"

@Pipe({
    name: 'diskSize',
    standalone: false
})
export class DiskSizePipe extends FileSizePipe {

  // @ts-ignore
  transform(value, args: {} = {}): unknown {
    // for now, we are not transforming special for cigent drives.  Perhaps we can use model to be
    // more marketing deterministic.

    // if ( false !== drive.cigent_drive) {
    //     if ( drive.capacity < (GB * 500) ) {
    //       return '480 GB';
    //     }
    //     if ( drive.capacity < TB ) {
    //       return '1 TB';
    //     }
    //     if ( drive.capacity < (TB * 2) ) {
    //       return '2 TB';
    //     }
    // }
    let transform = '';
    let size = 0;
    if ('capacity' in value) {
        const drive: IDrive = value;
        transform =  super.transform(drive.capacity, args).toString();
        size = drive.capacity;
    }
    if ('mount' in value) {
        const volume: IVolume = value;
        if (volume.size != null) {
            transform = super.transform(volume.size, args).toString()
            size = volume.size;
        }
    }

    if (transform != '' && !transform.endsWith('TB') && !transform.endsWith('TiB')) {
      transform = super.transform(size, Object.assign({round: 0}, args)).toString();
    }

    return transform;
  }

}
